<template>
  <div v-if="boo_modal" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0, 0, 0, 0.5)">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header bg-main text-white py-2">
          <h6 class="modal-title mb-0">
            <i class="fas fa-file-invoice me-2"></i>{{ title }}
          </h6>
          <button type="button" class="btn-close btn-close-white" @click="mtdClose"></button>
        </div>
        <div class="modal-body">
          <div class="table-responsive table-container">
            <table class="table table-sm table-bordered">
              <thead class="bg-main header-sticky" style="font-size: 13px">
                <tr class="text-white text-center align-middle">
                  <th scope="col">Fecha</th>
                  <th scope="col">Doctor</th>
                  <th scope="col">CMP / RNE</th>
                  <th scope="col">Paciente</th>
                  <th scope="col">Serie</th>
                  <th scope="col">Número</th>
                  <th scope="col">Cantidad</th>
                  <th scope="col">Devolución</th>
                </tr>
              </thead>
              <tbody class="border-main" style="font-size: 12px">
                <tr v-for="(item, index) in data" :key="index" class="text-center align-middle">
                  <td>{{ formatDate(item.date) }}</td>
                  <td>{{ item.doctor }}</td>
                  <td>
                    <span v-if="item.cpm">CMP: {{ item.cpm }}</span>
                    <span v-if="item.cpm && item.rne"> | </span>
                    <span v-if="item.rne">RNE: {{ item.rne }}</span>
                    <span v-if="!item.cpm && !item.rne">-</span>
                  </td>
                  <td>{{ item.patient }}</td>
                  <td>{{ item.serie }}</td>
                  <td>{{ item.number }}</td>
                  <td>{{ item.quantity }}</td>
                  <td>{{ item.devolution ?? 0 }}</td>
                </tr>

                <tr v-if="data && data.length > 0" style="background:#f5e6ee;font-weight:bold">
                  <td colspan="6" class="text-end">TOTAL</td>
                  <td class="text-center">{{ totals.quantity }}</td>
                  <td class="text-center">{{ totals.devolution }}</td>
                </tr>

                <tr v-if="!data || data.length === 0">
                  <td colspan="8" class="text-center">Sin datos</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="modal-footer py-2">
          <button type="button" class="btn btn-sm btn-secondary" @click="mtdClose">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "cModalViewDispatch",
  props: {
    title: {
      type: String,
      default: "",
    },
    boo_modal: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    totals() {
      return this.data.reduce(
        (acc, item) => {
          acc.quantity += Number(item.quantity || 0);
          acc.devolution += Number(item.devolution || 0);
          return acc;
        },
        {
          quantity: 0,
          devolution: 0,
        }
      );
    },
  },
  methods: {
    mtdClose: function () {
      this.$emit("mtdCloseModalViewDispatch");
    },
    formatDate(date) {
      if (!date) return "-";
      return moment(date).format("DD/MM/YYYY HH:mm");
    }
  },
};
</script>
<style scoped>
.align-middle {
  vertical-align: middle;
}

/* HEADER FIJO */
.header-sticky th {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #900052;
  color: #fff;
}
</style>